const color = {
    primary: {
        main: "#0078D4", // Modern blue as primary color
        light: "#4CA6E5",
        dark: "#005A9E",
        contrastText: "#FFFFFF",
    },
    secondary: {
        main: "#00B8A9", // Teal as secondary color
        light: "#4DCBBD",
        dark: "#008C80",
        contrastText: "#FFFFFF",
    },
    accent: {
        main: "#7E57C2", // Soft purple as accent
        light: "#A58FDB",
        dark: "#5E35B1",
    },
    success: {
        main: "#4CAF50", // Green for success states
        light: "#81C784",
        dark: "#388E3C",
    },
    warning: {
        main: "#FF9800", // Orange for warnings
        light: "#FFB74D",
        dark: "#F57C00",
    },
    error: {
        main: "#F44336", // Red for errors
        light: "#E57373",
        dark: "#D32F2F",
    },
    info: {
        main: "#2196F3", // Blue for info
        light: "#64B5F6",
        dark: "#1976D2",
    },
    grey: {
        50: "#FAFAFA",
        100: "#F5F5F5",
        200: "#EEEEEE",
        300: "#E0E0E0",
        400: "#BDBDBD",
        500: "#9E9E9E",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
    },
    background: {
        default: "#FFFFFF",
        paper: "#FFFFFF",
        light: "#F8FAFC",
        dark: "#121212",
    },
    text: {
        primary: "#2D3748", // Dark blue-grey for primary text
        secondary: "#718096", // Medium blue-grey for secondary text
        disabled: "#A0AEC0", // Light blue-grey for disabled text
        hint: "#A0AEC0", // Light blue-grey for hint text
    },
    divider: "rgba(0, 0, 0, 0.12)",
    white: {
        main: "#FFFFFF",
    },
    black: {
        main: "#000000",
    },
    navy: {
        main: "#041419",
        light: "#162A30",
        dark: "#020A0C",
    },
    // Legacy colors maintained for backward compatibility
    yellow: {
        main: "#F0C24A",
    },
    green: {
        main: "#4CAF50",
    },
    red: {
        main: "#F44336",
    },
    blue: {
        main: "#0078D4",
    },
    purple: {
        main: "#7E57C2",
    },
    pink: {
        main: "#EC407A",
    },
    gray: {
        main: "#F8F8F8",
    },
    topBarColor: {
        main: "#FFFFFF",
    },
    lightGreen: {
        main: "#4CAF50"
    },
    lightBlue: {
        main: "#2196F3"
    }
};

export default color;

